module.exports = __webpack_public_path__ + "media/images/cbs/map-home-54442bd1cd0e75e1d283d33979b2a0c9.png";